import { AxiosHelper } from "../axiosConfig";
import { IWorksheet } from "../model/interface/worksheet";
import APIConstant from "../utils/apiConstant";

export const getWorksheets = (
  worksheet: IWorksheet,
  pageSize: number,
  pageNumber: number,
  orderbyColumn: string,
  sortDir: string
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_WORKSHEETS, {
    params: {
      pageSize: pageSize,
      pageNumber: pageNumber,
      standardId: worksheet.standardId,
      standardName: worksheet.standardName,
      title: worksheet.title,
      description: worksheet.description,
      isApproved: worksheet.isApproved,
      isActive: worksheet.isActive,
      orderbyColumn: orderbyColumn,
      sortDir: sortDir,
      worksheetId: worksheet.worksheetId,
      tagIds: worksheet.worksheetTags,
      contentAreaId: worksheet.contentAreaId,
      gradeLevelId: worksheet.gradeLevelId,
    },
  });
};

export const getWorksheet = (id: number) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_WORKSHEET, {
    params: { id: id },
  });
};
export const getWorksheetPreviewURL = (id: number, path: string) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_WORKSHEET_PREVIEW, {
    params: { id: id, worksheetFile: path },
  });
};

export const getStandardWorksheets = (
  standardId: number,
  pageNumber: number,
  pageSize: number
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_STANDARD_WORKSHEETS, {
    params: {
      standardId: standardId,
      isActive: true,
      isApproved: true,
      pageNumber: pageNumber,
      pageSize: pageSize,
    },
  });
};

export const saveWorksheet = (formData) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_WORKSHEET,
    formData,
    {}
  );
};
export const deleteWorksheet = (
  id: number,
  worksheetFile?: string,
  worksheetKeyFile?: string
) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_WORKSHEET, {
    params: {
      id: id,
      worksheetFile: worksheetFile,
      worksheetKeyFile: worksheetKeyFile,
    },
  });
};

export const postWorksheetTag = (Tag) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_WORKSHEETTAG,
    Tag,
    {}
  );
};

export const deleteWorksheetTag = (tag) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_WORKSHEETTAG, {
    params: tag,
  });
};

export const unassociateWorksheetStandards = (
  worksheetId: number,
  standardIds: Array<number>
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_WORKSHEET_UNASSOCIATE_STANDARDS,
    {
      data: {
        worksheetId,
        standardIds,
      },
    }
  );
};
